// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sort-select>button{width:200px;border-radius:40px;background-color:#e8e8e8;border:0;color:#000}", ""]);
// Exports
module.exports = exports;
